import { Analytics, AnalyticsBrowser, Context } from '@segment/analytics-next'
import inEU from '@segment/in-eu'
import { createStore } from '@stencil/store'
import { throttle } from 'lodash-es'

import { ILayoutProps, SharedProps } from '../../app'

interface ISegmentAnalytics {
  context?: Context
  writeKey?: string
  analytics?: Analytics
}

export const SegmentStore = createStore<ISegmentAnalytics>({})

export async function loadSegment(writeKey: string) {
  SegmentStore.reset()
  SegmentStore.state.writeKey = writeKey
  try {
    const [analytics, context] = await AnalyticsBrowser.load({ writeKey: SegmentStore.state.writeKey })
    SegmentStore.state.analytics = analytics
    SegmentStore.state.context = context
  } catch (error) {
    if (error instanceof Error) {
      window.Sentry?.captureException(error)
    }
    SegmentStore.reset()
  }
}

export function shouldTrackSession(props: SharedProps) {
  if (props.inZapp || props.inElectron) {
    return false
  }

  if (!props.layout) {
    return false
  }

  const layoutProps = props.layout.props as ILayoutProps
  if (!layoutProps || !layoutProps.loadSegment) {
    return false
  }

  try {
    return !inEU()
  } catch (error) {
    if (error instanceof Error) {
      window.Sentry?.captureException(error)
    }
    return false
  }
}

export type TrackVideoProperties = Partial<{
  session_id: string
  url_path: string
  speed: number
  position: number
  seek_position: number
  seek_trigger_type: string
  seek_trigger_id: number
  total_length: number
  sound: number
  full_screen: boolean
  method: string
}>

export const trackVideoEvent = throttle((event: string, properties: TrackVideoProperties) => {
  if (SegmentStore.state.analytics?.initialized) {
    SegmentStore.state.analytics?.track(event, properties)
  }
}, 1000)
